import type { DateRangeFilterValue, FilterSelectedKey, RangeFilterValue } from '../TableViewTypes'

/**
 * The range dropdown only ever stores a `RangeFilterValue` in its column's `selectedKeys` slot; anything else
 * (an empty slot, or a stray scalar key) reads as "no range".
 */
export function rangeValueFromSelectedKey(key: FilterSelectedKey | undefined): RangeFilterValue {
  return typeof key === 'object' && key !== null ? (key as RangeFilterValue) : {}
}

/** Date-range counterpart of {@link rangeValueFromSelectedKey}. */
export function dateRangeValueFromSelectedKey(key: FilterSelectedKey | undefined): DateRangeFilterValue {
  return typeof key === 'object' && key !== null ? (key as DateRangeFilterValue) : {}
}

/** The text dropdown stores its search string in the slot; a missing or non-string key reads as "no text". */
export function textValueFromSelectedKey(key: FilterSelectedKey | undefined): string {
  return typeof key === 'string' ? key : ''
}
